'use client'

import classNames from 'classnames'
import React, { useState, type JSX } from 'react'

export type TabProps = {
  content?: JSX.Element
  key?: string
} & InnerHTMLProps

type InnerHTMLProps = {
  name: string
}

interface TabsProps {
  tabs: TabProps[]
}

const Tabs: React.FC<TabsProps> = ({ tabs = [] }) => {
  const [activeTab, setActiveTab] = useState(tabs[0].name)

  const tabContent = tabs.find((t) => t.name === activeTab)?.content || null

  return (
    <div className='flex flex-col gap-y-4'>
      <div className='flex divide-x-[1px]'>
        {tabs.map((tab) => {
          return (
            <div
              key={tab.name}
              className={classNames(
                'flex w-full items-center justify-center text-sm font-semibold text-primary first:rounded-l-sm last:rounded-r-sm',
                {
                  'bg-white/80 shadow-[inset_0_1px_8px_rgba(0,0,0,0.2)]':
                    tab.name === activeTab,
                  'bg-white': tab.name !== activeTab,
                },
              )}
            >
              <button
                className={classNames('px-2 py-2 sm:px-8 sm:py-4', {})}
                onClick={() => setActiveTab(tab.name)}
              >
                {tab.name}
              </button>
            </div>
          )
        })}
      </div>
      {tabContent && tabContent}
    </div>
  )
}

export default Tabs
